module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_SpatialResearch.b5918ee8.png";